export const getFileSizeInMb = (bytes: number) => {
  if (bytes < 1_000_000) return `${(bytes / 1024).toFixed(2)}KB`;
  return `${(bytes / (1024 * 1024)).toFixed(2)}MB`;
};
